import React from 'react';

class PlugIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_616)">
          <g filter="url(#filter0_d_241_616)">
            <path
              d="M29.9265 4C31.1685 4 32.1765 5.008 32.1765 6.25V22.782H27.4805V6.446C27.4805 5.096 28.5765 4 29.9265 4Z"
              fill="url(#paint0_linear_241_616)"
            />
            <path
              d="M50.2722 4C51.5142 4 52.5222 5.008 52.5222 6.25V22.782H47.8262V6.446C47.8262 5.096 48.9222 4 50.2722 4Z"
              fill="url(#paint1_linear_241_616)"
            />
            <path
              d="M61.9139 71.3039H18.0859V46.2599C18.0859 44.5319 19.4879 43.1299 21.2159 43.1299H58.7819C60.5099 43.1299 61.9119 44.5319 61.9119 46.2599V71.3039H61.9139Z"
              fill="#F7F4F1"
            />
            <path
              d="M42.3478 24.348V27.478H37.6518V24.348C37.6518 23.484 36.9518 22.782 36.0858 22.782H22.7818C21.9178 22.782 21.2158 23.482 21.2158 24.348V43.13H58.7818V24.348C58.7818 23.484 58.0818 22.782 57.2158 22.782H43.9118C43.0478 22.782 42.3458 23.482 42.3458 24.348H42.3478Z"
              fill="#F7F4F1"
            />
            <path
              d="M62.7141 46.26C62.7141 44.366 61.3681 42.782 59.5841 42.412V24.348C59.5841 23.044 58.5221 21.982 57.2181 21.982H53.3221V6.24995C53.3221 4.56795 51.9541 3.19995 50.2721 3.19995C48.4821 3.19995 47.0261 4.65595 47.0261 6.44595V21.982H43.9141C42.6101 21.982 41.5481 23.044 41.5481 24.348V26.678H38.4521V24.348C38.4521 23.044 37.3901 21.982 36.0861 21.982H32.9741V6.24995C32.9741 4.56795 31.6061 3.19995 29.9241 3.19995C28.1341 3.19995 26.6781 4.65595 26.6781 6.44595V21.982H22.7821C21.4781 21.982 20.4161 23.044 20.4161 24.348V42.412C18.6321 42.782 17.2861 44.368 17.2861 46.26V71.3039V74.436C17.2861 75.74 18.3461 76.7999 19.6501 76.7999H60.3461C61.6501 76.7999 62.7101 75.74 62.7101 74.436V71.306V46.262L62.7141 46.26ZM48.6261 6.44595C48.6261 5.53795 49.3641 4.79995 50.2721 4.79995C51.0721 4.79995 51.7221 5.44995 51.7221 6.24995V21.982H48.6261V6.44595ZM28.2801 6.44595C28.2801 5.53795 29.0181 4.79995 29.9261 4.79995C30.7261 4.79995 31.3761 5.44995 31.3761 6.24995V21.982H28.2801V6.44595ZM22.7841 23.582H36.0881C36.5101 23.582 36.8541 23.926 36.8541 24.348V27.478C36.8541 27.92 37.2121 28.278 37.6541 28.278H42.3501C42.7921 28.278 43.1501 27.92 43.1501 27.478V24.348C43.1501 23.926 43.4941 23.582 43.9161 23.582H57.2201C57.6421 23.582 57.9861 23.926 57.9861 24.348V42.33H22.0181V24.348C22.0181 23.926 22.3621 23.582 22.7841 23.582ZM18.8881 46.26C18.8881 44.976 19.9341 43.93 21.2181 43.93H58.7841C60.0681 43.93 61.1141 44.976 61.1141 46.26V70.504H18.8861V46.26H18.8881Z"
              fill="#84827E"
            />
            <path
              d="M42.8 54.8181H37.2C36.5373 54.8181 36 55.3554 36 56.0181V58.4181C36 59.0809 36.5373 59.6181 37.2 59.6181H42.8C43.4627 59.6181 44 59.0809 44 58.4181V56.0181C44 55.3554 43.4627 54.8181 42.8 54.8181Z"
              fill="url(#paint2_linear_241_616)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_616"
            x="15.8861"
            y="1.79995"
            width="51.4277"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_616"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_616"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_616"
            x1="28.141"
            y1="5.6799"
            x2="34.9618"
            y2="7.63608"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_616"
            x1="48.4867"
            y1="5.6799"
            x2="55.3074"
            y2="7.63606"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_241_616"
            x1="37.1252"
            y1="55.2474"
            x2="39.8268"
            y2="60.4123"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_616">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default PlugIcon;
